<template>
  <!-- 积分流水 -->
  <div class="integralWater">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['财务管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.start"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.end"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>

        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(objValue, key, index) in tableDataTitle"
        :key="index"
        align="center"
        :prop="key"
        show-overflow-tooltip
        :label="objValue"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "integralWater",
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"客户编号",
      //   name:"客户名称",
      //   type:"类型",
      //   change:"积分变动",
      //   integral:"变动后积分",
      //   newIntegral:"现存积分",
      //   time:"改动时间",
      //   number:"电商单号",
      //   ERP:"ERP单号"
      // }
      tableData: [],
      tableDataTitle: {},
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (!this.searchForm.start) {
        this.$message({
          message: "请输入开始时间",
          type: "warning",
        });
        return;
      }
      if (!this.searchForm.end) {
        this.$message({
          message: "请输入结束时间",
          type: "warning",
        });
        return;
      }
      let data = {
        type: "QueryUserBalanceHis",
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        PageSize: this.pageSize + "",
        PageIndex: this.currPage + "",
      };
      let Type = "ReturnList";
      this.$requestSys({
        url:
          "/goods/ashx/ReturnJson.ashx?type=" +
          Type +
          "&Json=" +
          encodeURI(JSON.stringify(data)) +
          "&proc=Proc_Admin_MembersQuery",
        method: "Post",
      })
        .then((res) => {
          console.log(res, "ssssssssssssss");
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;

            this.tableDataTitle = res.table;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.integralWater {
  width: 100%;
  height: 100%;
}
</style>